module.exports = __webpack_public_path__ + "img/tatsuki.b0d61082.jpg";